import api from './api';

export const MISC_SET_ORDERS_TOTAL = 'MISC_SET_ORDERS_TOTAL';

export default function reducer(state = {}, {type, payload}) {
  switch (type) {
    case MISC_SET_ORDERS_TOTAL:
      return {
        ...state,
        ordersTotal: payload
      };
    default:
      return state;
  }
}

export function setOrdersTotal(total) {
  // FIXME: fix the scam at some point?
  return {type: MISC_SET_ORDERS_TOTAL, payload: 11000 + total};
}

export function fetchOrdersTotal() {
  return dispatch => {
    dispatch(setOrdersTotal(null));

    return dispatch(api.get('orders/global-total'))
      .then((ordersTotalResponse) => dispatch(setOrdersTotal(ordersTotalResponse.content.total)));
  };
}



// WEBPACK FOOTER //
// ./ducks/misc.js